<template>
  <div>
    <a-card title="预约人数设置">
      <a-form :form="form">
        <a-form-item
          class="form_item_center"
          label="当前报名计划"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
        >
          <a-select v-decorator="['signupId']" placeholder="请选择报名计划" @change="handleSelectChange">
            <a-select-option
              v-for="(item, index) of signupList"
              :key="index"
              :value="item.signupNoticeId"
            >{{item.title}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="预约时间"
          class="form_item_center"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
        >
          <div class="order_set_read">
            <p>{{detail.reserveBegin}}～ {{detail.reserveEnd}}</p>
            <p>
              <span>上午：{{detail.amBegin}} ～ {{detail.amEnd}}</span>
              <span>下午：{{detail.pmBegin}} ～ {{detail.pmEnd}}</span>
            </p>
          </div>
        </a-form-item>
        <a-form-item
          label="预约人数设置"
          class="form_item_center"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
        >
          <div
            v-if="!!detail.quotas"
            v-for="item in detail.quotas"
            :key="item.quotaDate+'_'+item.amPmType"
          >
            <div>
              <a-date-picker :defaultValue="moment(item.quotaDate)" disabled />
              <a-select
                :defaultValue="item.amPmType"
                disabled
                style="width: 140px; margin: 0 22px;"
              >
                <a-select-option :value="1">上午</a-select-option>
                <a-select-option :value="2">下午</a-select-option>
              </a-select>
              <a-input-number :min="0" v-model="item.limitNum"></a-input-number>
            </div>
          </div>
        </a-form-item>
        <a-form-item class="form_item_center">
          <!-- {{isSignupEnd}} -->
          <a-button
            :disabled="!(signupList && signupList[0] && signupList[0].signupNoticeId===signupIdCurr) || isSignupEnd"
            type="primary"
            style="width: 100px"
            @click="handleSave"
          >保存</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import moment from "moment";
import AdminCommon from "./mixins/admin_common";

export default {
  mixins: [AdminCommon],
  data() {
    return {
      moment,
      defaultDate: moment("2020-01-01", "YYYY-MM-DD"),
      form: this.$form.createForm(this),
      signupIdCurr: "",
      signupList: [],
      detail: {},
      isSignupEnd: false
    };
  },
  created() {
    window._setStreet = this;
    this.ajaxGetSearchFormData();
  },
  methods: {
    async ajaxGetSearchFormData() {
      const [data1, data2] = await Promise.all([
        this.$ajax.gateway("/bm/ISignupNoticeApi_querySignupNotices", {
          studentType: this.studentType
        }),
        this.$ajax.gateway("/bm/IAreaApi_getMyAreas", {
          studentType: this.studentType
        })
      ]);
      let signupData = data1.data;
      let streetData = data2.data;

      // 处理获取的报名列表数据
      if (signupData.code === 200) {
        signupData = signupData.data;
        if (typeof signupData === "object" && signupData.length > 0) {
          this.signupList = signupData;
          this.form.setFieldsValue({
            signupId: this.signupList[0].signupNoticeId
          });
          this.isSignupEnd = moment(Date.now()).isAfter(this.signupList[0].signupEnd)
          // await this.onSignupChange(this.signupList[0].signupNoticeId);
          await this.handleSelectChange(this.signupList[0].signupNoticeId);
        }
      }
      // 处理获取的街道列表数据
      // if (streetData.code === 200) {
      //   if (typeof streetData.data === "object" && streetData.data.length > 0) {
      //     // 街道
      //     this.streetList = streetData.data;
      //     this.$store.commit("setStreetList", streetData.data);
      //     if (this.adminLevel === "street") {
      //       this.villageList = streetData.data[0].children || [];
      //     }
      //   }
      // }
    },
    /**
     * 点击保存 提交人数设置
     */
    async handleSave() {
      const formVal = this.form.getFieldsValue();
      let { data } = await this.$ajax.gateway(
        "/bm/ISignupQuotaApi_updateOrAdd",
        {
          body: {
            areaCode: this.$store.state.user.systemInfo.streetCode,
            areaName: this.$store.state.user.areaName,
            noticeId: formVal.signupId,
            quotas: this.detail.quotas,
            studentType: 2,
            targetType: 2
          }
        }
      );
      if (data.data)
        this.$success({
          title: "提示",
          content: "设置成功！",
          onOk() {
            window.location.reload();
          }
        });
    },
    /**
     * 选择报名计划
     */
    async handleSelectChange(value) {
      this.isSignupEnd = this.signupList[0] && moment(Date.now()).isAfter(this.signupList[0].signupEnd);
      let { data } = await this.$ajax.gateway("/bm/ISignupQuotaApi_areaInfo", {
        METHOD: "get",
        areaCode: this.$store.state.user.systemInfo.streetCode,
        noticeId: value
      });
      this.signupIdCurr = value;
      const days =
        moment(data.data.reserveEnd).diff(data.data.reserveBegin, "days") + 1;
      console.log("预约时间是多少天", days);
      this.detail = data.data;
      this.detail.quotas = data.data.quotas || [];
      // 构造
      if (!this.detail.quotas || this.detail.quotas.length === 0) {
        let list = [];
        for (let i = 0; i < days; i++) {
          list.push({
            id: "",
            signupNoticeId: value,
            quotaDate: moment(data.data.reserveBegin).add(i, "days"),
            amPmType: 1,
            limitNum: 0,
            targetCode: this.$store.state.user.systemInfo.streetCode,
            targetName: this.$store.state.user.systemInfo.streetName,
            targetType: 2
          });
          list.push({
            id: "",
            signupNoticeId: value,
            quotaDate: moment(data.data.reserveBegin).add(i, "days"),
            amPmType: 2,
            limitNum: 0,
            targetCode: this.$store.state.user.systemInfo.streetCode,
            targetName: this.$store.state.user.systemInfo.streetName,
            targetType: 2
          });
        }
        this.detail.quotas = list;
      }
      console.log(this.detail);
    }
  }
};
</script>

<style lang="stylus" scoped>
.form_item_center {
  display: flex;
  justify-content: center;

  .order_set_read {
    background: rgba(230, 247, 255, 1);
    border-radius: 4px;
    padding: 5px;

    & > p {
      margin: 0;
    }
  }
}
</style>